import React from "react";
import ChartLegend from "./ChartLegend";
import ResponsiveD3Container from "../rendering/ResponsiveD3Container";
import styles from "./ExpandedChartLayout.module.css";

export interface ExpandedChartLayoutProps {
  legendItems?: string[];
  legendTitle?: string | null;
  colorOf: (c: string) => string;
  height?: number;
  children?: React.ReactNode;
  controls?: React.ReactNode | null;
  rightControls?: React.ReactNode | null;
  legendSelectable?: boolean;
  selectedLegendItems?: string[];
  onToggleLegend?: ((item: string) => void) | null;
  showLegend?: boolean;
}

const ExpandedChartLayout: React.FC<ExpandedChartLayoutProps> = ({
  legendItems = [],
  legendTitle = "Legend",
  colorOf,
  height = 380,
  children,
  controls = null,
  rightControls = null,
  legendSelectable = false,
  selectedLegendItems = [],
  onToggleLegend = null,
  showLegend = true,
}) => {
  return (
    <div className={styles.container}>
      {rightControls && <div className={styles.rightControlsWrapper}>{rightControls}</div>}

      <div className={styles.gridContainer} style={{ minHeight: height }}>
        {showLegend && (
          <div className={styles.legendColumn} style={{ height: height }}>
            {controls && <div className={styles.controlsWrapper}>{controls}</div>}
            {legendTitle && (
              <div className={styles.legendTitleWrapper}>
                <span className={styles.legendTitle}>{legendTitle}:</span>
              </div>
            )}
            <div className={styles.legendScrollContainer}>
              <ChartLegend
                items={legendItems}
                colorOf={colorOf}
                title={null}
                showCheckboxes={legendSelectable}
                checkedItems={selectedLegendItems}
                onToggle={onToggleLegend || undefined}
              />
            </div>
          </div>
        )}

        <div
          className={`${styles.chartColumn} ${showLegend ? styles.chartColumnWithLegend : styles.chartColumnFull}`}
          style={{ height: height }}
        >
          <ResponsiveD3Container width="100%" height={height}>
            {children}
          </ResponsiveD3Container>
        </div>
      </div>
    </div>
  );
};

export default ExpandedChartLayout;
